var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66602 3.33329V13.3333C4.66602 13.7753 4.84161 14.1992 5.15417 14.5118C5.46673 14.8244 5.89065 15 6.33268 15H12.9993C13.4414 15 13.8653 14.8244 14.1779 14.5118C14.4904 14.1992 14.666 13.7753 14.666 13.3333V6.03496C14.666 5.81293 14.6216 5.59314 14.5354 5.3885C14.4493 5.18386 14.3231 4.99849 14.1643 4.84329L11.4018 2.14163C11.0905 1.83717 10.6723 1.66668 10.2368 1.66663H6.33268C5.89065 1.66663 5.46673 1.84222 5.15417 2.15478C4.84161 2.46734 4.66602 2.89127 4.66602 3.33329V3.33329Z",
    stroke: "#824ED2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.333 14.9999V16.6666C11.333 17.1086 11.1574 17.5325 10.8449 17.8451C10.5323 18.1577 10.1084 18.3333 9.66634 18.3333H2.99967C2.55765 18.3333 2.13372 18.1577 1.82116 17.8451C1.5086 17.5325 1.33301 17.1086 1.33301 16.6666V7.49992C1.33301 7.05789 1.5086 6.63397 1.82116 6.32141C2.13372 6.00885 2.55765 5.83325 2.99967 5.83325H4.66634",
    stroke: "#824ED2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.8e2761ce32b8062eff209d564109b61a.svg";
export { ForwardRef as ReactComponent };